import { useNavigate, useLocation } from "react-router-dom";
import { Box, Button, Typography, Paper } from "@mui/material";
import { useAuth } from "../contexts/authContext";
import { setSelectedRole } from "../utils/auth";

const RoleSelection = () => {
  const navigate = useNavigate();
  const { user, initials, avatarColor, setUser } = useAuth();
  const location = useLocation();
  const { roles } = location.state || {};

  const handleRoleSelect = (role) => {
    setUser((prevUser) => {
      const updatedUser = { ...prevUser, role };
      setSelectedRole(role);
      return updatedUser;
    });

    navigate(getDashboardPath(role));
  };

  const getDashboardPath = (role) => {
    const rolePaths = {
      Admin: "/admin/",
      Issuer: "/issuer/",
      User: "/user/",
      CompanyAdmin: "/company-admin/",
    };

    return rolePaths[role] || "/";
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
    >
      <Paper elevation={3} sx={{ padding: 4, textAlign: "center", borderRadius: 2 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Select Your Role
        </Typography>
        <Box display="flex" flexDirection="column" gap={2}>
          {roles.map((role) => (
            <Button
              key={role}
              variant="contained"
              color="primary"
              onClick={() => handleRoleSelect(role)}
            >
              Login as {role}
            </Button>
          ))}
        </Box>
      </Paper>
    </Box>
  );
};

export default RoleSelection;
